(function() { window.GUID_3bf3bdc6_1d2e_47bc_9aa5_7e6143b0e5a5 = { getGuid: function() { return "3bf3bdc6-1d2e-47bc-9aa5-7e6143b0e5a5"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        let ChecboxEventBypass;
        (function (ChecboxEventBypass) {
            ChecboxEventBypass[ChecboxEventBypass["None"] = 0] = "None";
            ChecboxEventBypass[ChecboxEventBypass["BeforeCheckboxValueChanged"] = 1] = "BeforeCheckboxValueChanged";
            ChecboxEventBypass[ChecboxEventBypass["CheckboxValueChanged"] = 2] = "CheckboxValueChanged";
            ChecboxEventBypass[ChecboxEventBypass["Both"] = 3] = "Both";
        })(ChecboxEventBypass = Controls.ChecboxEventBypass || (Controls.ChecboxEventBypass = {}));
        class CheckBox extends Controls.ControlValueBase {
            constructor() {
                super(...arguments);
                this.preventValueChange = false;
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnDispose() {
                this.$Control.off('click.' + this.ControlId).off('keydown');
                this.$Control.remove();
            }
            OnBindEvents() {
            }
            get ExtraData() {
                return this.extraData;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $('#' + this.controlId);
                let me = this;
                let colors = me.$Control.data('colors');
                if (colors != null) {
                    me.colors = colors.split(",");
                }
                me.threestatemode = me.$Control.data('threestatemode');
                me.IsDisabled = me.$Control.data('disabled');
                me.nullable = me.$Control.data('nullable');
                me.$checkbox = me.$Control.find('input[type=checkbox]');
                me.$hidden = me.$Control.find('#' + me.ControlId + '-hidden');
                if (me.$Control.data('indeterminate') == true) {
                    me.SetValue(null, ChecboxEventBypass.Both);
                }
                me.lastValue = me.GetValue();
                me.firstState = me.GetValue();
                me.extraData = me.$Control.data("html");
                me.$Control.on('keydown', function (e) {
                    if (e.keyCode == 32) { //spacebar
                        e.preventDefault();
                        me.$Control.trigger('click');
                    }
                }).offon('click.' + this.ControlId, function (e) {
                    if (me.IsDisabled) {
                        me.Trigger(CheckBox.EventNames.DisabledCheckboxClicked, {
                            jqueryEventObject: e,
                            data: {
                                firstState: me.firstState,
                                value: me.lastValue,
                                nullable: me.nullable,
                                threestatemode: me.threestatemode,
                                extraData: me.extraData
                            }
                        });
                        return;
                    }
                    if (me.$Control.hasClass('isreadonly')) {
                        e.preventDefault();
                        return;
                    }
                    let currentValue = me.GetValue();
                    if (currentValue == null) {
                        if (me.lastValue == "true") {
                            me.SetValue(false, null, e);
                        }
                        else {
                            me.SetValue(true, null, e);
                        }
                    }
                    else if (currentValue == "true") {
                        if (me.threestatemode && me.nullable && me.firstState != "true" && me.firstState != null) {
                            me.SetValue(null, null, e);
                        }
                        else {
                            me.SetValue(false, null, e);
                        }
                    }
                    else {
                        if (me.threestatemode && me.nullable && me.firstState != "false") {
                            me.SetValue(null, null, e);
                        }
                        else {
                            me.SetValue(true, null, e);
                        }
                    }
                });
            } //ValueBaseControl<CheckBox> {
            PreventValueChangeOnce() {
                this.preventValueChange = true;
            }
            get IsChecked() {
                return this.$checkbox.is(':checked');
            }
            GetValue() {
                if (this.$checkbox != null && this.$checkbox && !this.$checkbox.length || this.$checkbox.is(':indeterminate')) {
                    return null;
                }
                else {
                    if (this.$checkbox != null && this.$checkbox) {
                        return this.$checkbox.prop('checked') ? 'true' : 'false';
                        //return this.$checkbox.prop('checked').toString();
                    }
                    else {
                        return "false";
                    }
                }
            }
            refreshStateVisualState() {
                let newValue = this.GetValue();
                if (newValue == null) {
                    this.$Control.removeClass('checked');
                    this.$Control.removeClass('unchecked');
                    this.$Control.addClass('indeterminated');
                    if (this.colors != null) {
                        this.$Control.removeClass(this.colors[0]);
                        this.$Control.removeClass(this.colors[1]);
                    }
                }
                else {
                    this.$Control.removeClass('indeterminated');
                    if (newValue == "true") {
                        this.$Control.addClass('checked');
                        this.$Control.removeClass('unchecked');
                        if (this.colors != null) {
                            this.$Control.addClass(this.colors[0]);
                            this.$Control.removeClass(this.colors[1]);
                        }
                    }
                    else {
                        this.$Control.removeClass('checked');
                        this.$Control.addClass('unchecked');
                        if (this.colors != null) {
                            this.$Control.removeClass(this.colors[0]);
                            this.$Control.addClass(this.colors[1]);
                        }
                    }
                }
            }
            SetValue(value, bypassEvents = ChecboxEventBypass.None, jqueryEventObject = null) {
                if (bypassEvents != ChecboxEventBypass.Both && bypassEvents != ChecboxEventBypass.BeforeCheckboxValueChanged) {
                    this.Trigger(CheckBox.EventNames.BeforeCheckboxValueChanged, {
                        jqueryEventObject: jqueryEventObject,
                        data: {
                            firstState: this.firstState,
                            value: this.lastValue,
                            nullable: this.nullable,
                            threestatemode: this.threestatemode,
                            extraData: this.extraData
                        }
                    });
                }
                if (this.IsDisabled) {
                    return;
                }
                if (this.preventValueChange) {
                    this.preventValueChange = false;
                    return;
                }
                let boolValue = null;
                if (typeof (value) == "string") {
                    boolValue = value.toLowerCase() == "true" || value.toLowerCase() == "1";
                    value = boolValue;
                }
                if (value == null && this.threestatemode) {
                    this.$checkbox.prop("indeterminate", true);
                    this.$checkbox.prop('checked', false);
                    this.$hidden.val(null);
                    boolValue = null;
                }
                else {
                    if (value == null) {
                        value = false;
                        boolValue = false;
                    }
                    this.$checkbox.prop('checked', value);
                    this.$checkbox.prop("indeterminate", false);
                    this.$hidden.val("false");
                }
                this.lastValue = this.GetValue();
                this.refreshStateVisualState();
                if (bypassEvents != ChecboxEventBypass.Both && bypassEvents != ChecboxEventBypass.CheckboxValueChanged) {
                    this.$Control.trigger('change');
                    this.Trigger(CheckBox.EventNames.CheckboxValueChanged, {
                        jqueryEventObject: jqueryEventObject,
                        data: {
                            firstState: this.firstState,
                            value: this.lastValue,
                            nullable: this.nullable,
                            threestatemode: this.threestatemode,
                            extraData: this.extraData
                        }
                    });
                }
            }
        }
        Controls.CheckBox = CheckBox;
        (function (CheckBox) {
            class Events extends Controls.ControlValueBase.Events {
                static DisabledCheckboxClicked(param) {
                    Controls.RegisterEvent(CheckBox, EventNames.DisabledCheckboxClicked, param);
                }
                static BeforeCheckboxValueChanged(param) {
                    Controls.RegisterEvent(CheckBox, EventNames.BeforeCheckboxValueChanged, param);
                }
                static CheckboxValueChanged(param) {
                    Controls.RegisterEvent(CheckBox, EventNames.CheckboxValueChanged, param);
                }
            }
            CheckBox.Events = Events;
            class EventNames extends Controls.ControlValueBase.EventNames {
            }
            EventNames.BeforeCheckboxValueChanged = "checkbox-beforevaluechanged";
            EventNames.CheckboxValueChanged = "checkbox-valuechanged";
            EventNames.DisabledCheckboxClicked = "checkbox-disabled-clicked";
            CheckBox.EventNames = EventNames;
        })(CheckBox = Controls.CheckBox || (Controls.CheckBox = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=checkbox.js.map
